import SVG from "react-inlinesvg";
import classNames from "classnames";

import arrowRightDarkSVG from "./assets/arrow-right-dark.svg";
import backArrowSVG from "./assets/back-arrow.svg";
import checkmarkSVG from "./assets/checkmark.svg";
import checkThinSVG from "./assets/check-thin.svg";
import chevronIcon from "./assets/chevron.svg";
import crossNewIconSvg from "./assets/cross-new.svg";
import crossNewIconLargeSvg from "./assets/cross-new-large.svg";
import emailIcon from "./assets/email-icon.svg";
import fitLogoSvg from "./assets/ft-logo.svg";
import lockIconSVG from "./assets/lock.svg";
import lockProIconSVG from "./assets/lock-pro.svg";
import profileIconSvg from "./assets/profile.svg";
import searchNewIconSvg from "./assets/search-new.svg";
import settingsSVG from "./assets/settings-icon.svg";
import siftedLogoLoginFlow from "./assets/sifted-logo-login-flow.svg";
import siftedLogoSVG from "./assets/sifted-logo.svg";
import unlockIconSVG from "./assets/unlock.svg";
import externalLink from "./assets/externalLink.svg";
import xLogo from "./assets/x-logo.svg";
import linkedInIcon from "./assets/linkedIn-logo.svg";
import facebookLogo from "./assets/facebook-logo.svg";
import instagramLogo from "./assets/instagram-logo.svg";
import copyIcon from "./assets/copy-icon.svg";
import signalIcon from "./assets/signal.svg";
import filterIconSVG from "./assets/filter.svg";
import thumbUpIconSVG from "./assets/thumb-up.svg";
import penSVG from "./assets/pen.svg";
import warningSVG from "./assets/warning.svg";
import eyeOpenSVG from "./assets/eye-open.svg";
import eyeClosedSVG from "./assets/eye-closed.svg";
import locationIconSVG from "./assets/location-icon.svg";
import rocketIconSVG from "./assets/rocket-icon.svg";
import deleteBinIconSVG from "./assets/delete-bin.svg";
import logoutIconSVG from "./assets/logout.svg";
import siftedLogoSmallSVG from "./assets/sifted-logo-small.svg";
import breadcrumbSeparatorSVG from "./assets/breadcrumb-separator.svg";
import breakoutLogoAikidoSVG from "./assets/breakout-logo-aikido.svg";
import breakoutLogoCuspAiSVG from "./assets/breakout-logo-cusp-ai.svg";
import breakoutLogoElevenLabsSVG from "./assets/breakout-logo-eleven-labs.svg";
import breakoutLogoFractileSVG from "./assets/breakout-logo-fractile.svg";
import breakoutLogoHelsingSVG from "./assets/breakout-logo-helsing.svg";
import breakoutLogoIsarAerospaceSVG from "./assets/breakout-logo-isar-aerospace.svg";
import breakoutLogoLegoraSVG from "./assets/breakout-logo-legora.svg";
import breakoutLogoLovableSVG from "./assets/breakout-logo-lovable.svg";
import breakoutLogoPhysicsXSVG from "./assets/breakout-logo-physics-x.svg";
import breakoutLogoProximaFusionSVG from "./assets/breakout-logo-proxima-fusion.svg";
import breakoutLogoStarkSVG from "./assets/breakout-logo-stark.svg";
import breakoutLogoWayveSVG from "./assets/breakout-logo-wayve.svg";
import breakoutLogoScanComSVG from "./assets/breakout-logo-scan-com.svg";

const generateIconComponent =
  (svg, title = null, description = null) =>
  (props) => (
    <SVG src={svg} title={title} description={description} {...props} />
  );

export const FtLogo = generateIconComponent(
  fitLogoSvg,
  "Backed by The Financial Times"
);

export const SiftedLogoLoginFlow = generateIconComponent(
  siftedLogoLoginFlow,
  "Sifted logo"
);
export const SiftedLogo = generateIconComponent(siftedLogoSVG, "Sifted logo");

export const SignalIcon = generateIconComponent(signalIcon, "Signal logo");
export const LinkedInLogo = generateIconComponent(
  linkedInIcon,
  "LinkedIn logo"
);
export const XLogo = generateIconComponent(xLogo, "Twitter logo");
export const FacebookLogo = generateIconComponent(
  facebookLogo,
  "Facebook logo"
);
export const InstagramLogo = generateIconComponent(
  instagramLogo,
  "Instagram logo"
);
export const CopyIcon = generateIconComponent(copyIcon, "Copy");
export const EmailIcon = generateIconComponent(emailIcon, "Email");
export const ExternalLink = generateIconComponent(externalLink);
export const ArrowRightDark = generateIconComponent(arrowRightDarkSVG);
export const SettingsIcon = generateIconComponent(settingsSVG, "Settings icon");
export const CheckmarkIcon = generateIconComponent(checkmarkSVG, "Tick");
export const CheckThinIcon = generateIconComponent(checkThinSVG, "Tick");
export const BackArrowIcon = generateIconComponent(backArrowSVG, "Back arrow");
export const ChevronIcon = generateIconComponent(chevronIcon, "Close");

const BaseChevronIcon = generateIconComponent(chevronIcon, "Close");
export const ChevronIconWithDirection = ({
  direction = "down",
  className,
  ...props
}) => {
  const rotationClasses = {
    right: "-rotate-90",
    left: "rotate-90",
    up: "rotate-180",
    down: "",
  };
  const rotation = rotationClasses[direction] || "";
  return (
    <BaseChevronIcon {...props} className={classNames(rotation, className)} />
  );
};

export const LockIcon = generateIconComponent(lockIconSVG, "Closed lock");
export const LockProIcon = generateIconComponent(lockProIconSVG, "Pro only");
export const UnlockIcon = generateIconComponent(unlockIconSVG, "Open lock");
export const SearchNewIcon = generateIconComponent(searchNewIconSvg, "Search");
export const CrossNewIcon = generateIconComponent(crossNewIconSvg, "Close");
export const CrossNewIconLarge = generateIconComponent(
  crossNewIconLargeSvg,
  "Close"
);
export const ProfileIcon = generateIconComponent(
  profileIconSvg,
  "User Profile"
);

export const FilterIcon = generateIconComponent(filterIconSVG, "Filter Icon");
export const ThumbUpIcon = generateIconComponent(
  thumbUpIconSVG,
  "Thumb Up Icon"
);

export const PenIcon = generateIconComponent(penSVG);
export const WarningIcon = generateIconComponent(warningSVG);
export const EyeOpenIcon = generateIconComponent(eyeOpenSVG);
export const EyeClosedIcon = generateIconComponent(eyeClosedSVG);
export const LocationIcon = generateIconComponent(
  locationIconSVG,
  "Location Icon"
);
export const RocketIcon = generateIconComponent(rocketIconSVG, "Rocket Icon");
export const DeleteBinIcon = generateIconComponent(
  deleteBinIconSVG,
  "Delete Bin Icon"
);

export const LogoutIcon = generateIconComponent(logoutIconSVG, "Logout Icon");
export const SiftedLogoSmall = generateIconComponent(
  siftedLogoSmallSVG,
  "Sifted Logo Small"
);
export const BreadcrumbSeparator = generateIconComponent(
  breadcrumbSeparatorSVG,
  "Separator"
);

// Company logos for the Find your next breakout map scene (SIFDEV-1383).
// No title: the scene labels each logo's wrapper instead.
export const BreakoutLogoAikido = generateIconComponent(breakoutLogoAikidoSVG);
export const BreakoutLogoCuspAi = generateIconComponent(breakoutLogoCuspAiSVG);
export const BreakoutLogoElevenLabs = generateIconComponent(
  breakoutLogoElevenLabsSVG
);
export const BreakoutLogoFractile = generateIconComponent(
  breakoutLogoFractileSVG
);
export const BreakoutLogoHelsing = generateIconComponent(
  breakoutLogoHelsingSVG
);
export const BreakoutLogoIsarAerospace = generateIconComponent(
  breakoutLogoIsarAerospaceSVG
);
export const BreakoutLogoLegora = generateIconComponent(breakoutLogoLegoraSVG);
export const BreakoutLogoLovable = generateIconComponent(
  breakoutLogoLovableSVG
);
export const BreakoutLogoPhysicsX = generateIconComponent(
  breakoutLogoPhysicsXSVG
);
export const BreakoutLogoProximaFusion = generateIconComponent(
  breakoutLogoProximaFusionSVG
);
export const BreakoutLogoStark = generateIconComponent(breakoutLogoStarkSVG);
export const BreakoutLogoWayve = generateIconComponent(breakoutLogoWayveSVG);
export const BreakoutLogoScanCom = generateIconComponent(
  breakoutLogoScanComSVG
);
